import createTheme from "@material-ui/core/styles/createTheme";
import { blue } from "@material-ui/core/colors";
import { TypographyStyleOptions } from "@material-ui/core/styles/createTypography";

const headerCommon: TypographyStyleOptions = {
  fontFamily: ["Domine", "Noto Sans KR"].join(","),
  fontSize: "36px",
  letterSpacing: "-.025em",
  fontWeight: "bold",
  color: "rgb(36, 42, 49)",
  lineHeight: "1.5",
};

const bodyCommon: TypographyStyleOptions = {
  fontFamily: ["Open Sans", "Noto Sans KR"].join(","),
  fontSize: "18px",
  lineHeight: "1.5",
  color: "rgb(59, 69, 78)",
};

const theme = createTheme({
  overrides: {
    MuiCssBaseline: {
      "@global": {
        html: {
          WebkitFontSmoothing: "antialiased",
          fontSize: "18px",
          wordBreak: "break-all",
        },
      },
    },
  },
  palette: {
    primary: blue,
    background: {
      default: "white",
    },
  },
  typography: {
    h1: {
      ...headerCommon,
      fontSize: "36px",
      lineHeight: "1.5",
    },
    h2: {
      ...headerCommon,
      fontSize: "22px",
    },
    h3: {
      ...headerCommon,
      fontSize: "20px",
    },
    h4: {
      ...headerCommon,
      fontSize: "18px",
    },
    h5: {
      ...headerCommon,
      fontSize: "18px",
    },
    h6: {
      ...headerCommon,
      fontFamily: ["Open Sans", "Noto Sans KR"].join(","),
      fontSize: "18px",
      fontWeight: "bold",
    },
    body1: {
      ...bodyCommon,
    },
    body2: {
      ...bodyCommon,
    },
  },
});

export default theme;
